import React, { useEffect, useState } from "react";
import BookingModal from "./components/BookingModal";
import ContactForm from "./components/ContactForm";
import Navbar from "./components/Navbar";
import Services from "./components/Services";
import Skills from "./components/Skills";
import TechTicker from "./components/TechTicker";
import Loading from "./components/loading";
import { BookingProvider } from "./context/BookingContext";
import Home from "./pages/Home";
import Projects from "./pages/projects";

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      const delay =
        typeof window !== "undefined" &&
        window.matchMedia("(max-width: 768px)").matches
          ? 800
          : 1800;
      await new Promise((resolve) => setTimeout(resolve, delay));
      setIsLoading(false);
    };
    fetchData();
  }, []);

  return (
    <BookingProvider>
      <div className="min-h-screen bg-background text-foreground transition-colors duration-300">
        <a
          className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 z-[100]
                     rounded-md bg-background px-4 py-3 text-foreground shadow-elevated outline-none
                     ring-2 ring-primary"
          href="#main-content"
        >
          Skip to main content
        </a>

        {isLoading ? (
          <div className="flex items-center justify-center h-screen">
            <Loading />
          </div>
        ) : (
          <>
            <Navbar />
            <main id="main-content" tabIndex="-1">
              <Home id="mainy" />
              <TechTicker />
              <Services />
              <Projects id="case-studies" />
              <Skills id="skills" />
              <ContactForm id="contact" />
            </main>
            <BookingModal />
          </>
        )}
      </div>
    </BookingProvider>
  );
}

export default App;
